import { useAuthStore } from '#/shared/lib/auth'

export function useDefaultOwnerSettled(
  ownerUserIdInUrl: string | null,
): boolean {
  const hasCurrentUser = useAuthStore((s) => Boolean(s.user?.id))
  if (ownerUserIdInUrl != null) return true
  return !hasCurrentUser
}
